module.exports = __webpack_public_path__ + "static/media/rupee_symbol_selected.3bf4c13d.svg";